import { keyframes, styled } from 'styled-components';

import { AnimatedCheckmark } from '#/components/Icon/AnimatedCheckmark';
import { colors } from '#/theme/theme';

const aFillIn = keyframes`
    0% {
      transform: scale(0.5);
      background: transparent;
    }
    100% {
      transform: scale(1);
      background: ${colors.brandGreen};
    }
`;

const SuccessCheckmarkContainer = styled.div`
  animation: ${aFillIn} 0.75s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
`;

type Props = {
  containerSize: number;
  iconSize: number;
};

export function SuccessCheckmark({ containerSize, iconSize }: Props) {
  return (
    <SuccessCheckmarkContainer
      style={{
        height: `${containerSize}px`,
        width: `${containerSize}px`,
      }}
    >
      <AnimatedCheckmark size={iconSize} colorName="selectionGrey" />
    </SuccessCheckmarkContainer>
  );
}
